function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import hotkeys from 'hotkeys-js';
import { StimulusUse } from '../stimulus-use';
export class UseHotkeys extends StimulusUse {
  constructor(controller, hotkeysOptions) {
    super(controller, hotkeysOptions);
    this.bind = () => {
      for (const _ref of Object.entries(this.hotkeysOptions.hotkeys)) {
        var _ref2 = _slicedToArray(_ref, 2);
        const hotkey = _ref2[0];
        const definition = _ref2[1];
        const handler = definition.handler.bind(this.controller);
        hotkeys(hotkey, definition.options, e => handler(e, e));
      }
    };
    this.unbind = () => {
      for (const hotkey in this.hotkeysOptions.hotkeys) {
        hotkeys.unbind(hotkey);
      }
    };
    this.controller = controller;
    this.hotkeysOptions = hotkeysOptions;
    this.enhanceController();
    this.bind();
  }
  enhanceController() {
    if (this.hotkeysOptions.filter) {
      hotkeys.filter = this.hotkeysOptions.filter;
    }
    const controllerDisconnect = this.controller.disconnect.bind(this.controller);
    const disconnect = () => {
      this.unbind();
      controllerDisconnect();
    };
    Object.assign(this.controller, {
      disconnect
    });
  }
}
const convertSimpleHotkeyDefinition = definition => {
  return {
    handler: definition[0],
    options: {
      element: definition[1]
    }
  };
};
const coerceOptions = options => {
  if (!options.hotkeys) {
    const hotkeys = {};
    Object.entries(options).forEach(([hotkey, definition]) => {
      Object.defineProperty(hotkeys, hotkey, {
        value: convertSimpleHotkeyDefinition(definition),
        writable: false,
        enumerable: true
      });
    });
    options = {
      hotkeys
    };
  }
  return options;
};
export const useHotkeys = (controller, options) => {
  return new UseHotkeys(controller, coerceOptions(options));
};